import { ReactNode } from 'react';
import {
  DevHubButton,
  DevHubCard,
  DevHubCardContent,
  DevHubColorProps,
} from '@devxdiscover/devhub-ui';
import { appThemeApiRef, useApi } from '@backstage/core-plugin-api';
import { useNavigate } from 'react-router-dom';

/**
 * The workbox is a container for the workbox components.
 * @param props - The props for the workbox component.
 * @constructor
 */
export const Workbox = (props: {
  autoHeight?: boolean;
  consistentHeight?: boolean;
  actionItem?: ReactNode;
  color: DevHubColorProps;
  component?: string;
  title?: string;
  subHeader?: string;
  info?: string;
  children: ReactNode;
  showButton?: boolean;
  buttonTitle?: string;
  navigatePath?: string;
}) => {
  const {
    autoHeight = false,
    consistentHeight = false,
    actionItem,
    color,
    title,
    subHeader,
    children,
    showButton,
    buttonTitle,
    navigatePath,
  } = props;

  const navigate = useNavigate();
  const onClick = () => {
    if (navigatePath) {
      navigate(navigatePath);
    }
  };

  const themeRef = useApi(appThemeApiRef);
  const themeId = themeRef.getActiveThemeId();

  return (
    <DevHubCard
      density="workbox"
      autoHeight={autoHeight}
      actionItem={actionItem}
      title={title}
      decorateTitle={themeId !== 'devhub-dark'}
      workBoxTitleColor={color}
      subTitle={subHeader}
      consistentHeight={consistentHeight}
      topBorder="custom"
      topBorderColor={color}
      cardButtonPosition="workbox"
      cardButton={
        showButton && (
          <DevHubButton fullWidth buttonColor="themeBased" onClick={onClick}>
            {buttonTitle}
          </DevHubButton>
        )
      }
      body={
        <>
          <DevHubCardContent>{children}</DevHubCardContent>
        </>
      }
    />
  );
};
